export const LowPriorityIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7095_22518)">
        <path
          d="M4.6665 4.66699L7.99984 8.00033L11.3332 4.66699"
          stroke="#0D6EFD"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6665 8.66699L7.99984 12.0003L11.3332 8.66699"
          stroke="#0D6EFD"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7095_22518">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
